import { render, staticRenderFns } from "./TabFilterLanguage.vue?vue&type=template&id=0a908691&scoped=true&"
import script from "./TabFilterLanguage.vue?vue&type=script&lang=coffee&"
export * from "./TabFilterLanguage.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a908691",
  null
  
)

export default component.exports